type Props = {
  state: 'detecting' | 'no-tg' | 'auth-failed';
  error?: string;
  onRetry?: () => void;
};

const BOT_LINK = 'https://t.me/skinstep_bot';

export function TgGate({ state, error, onRetry }: Props) {
  return (
    <div className="min-h-dvh mx-auto max-w-[480px] px-6 py-16 flex flex-col items-center justify-center text-center">
      <div className="font-display font-bold text-[28px] tracking-tight text-fg mb-2">
        skin<span className="text-primary">step</span>
        <span className="text-accent">_</span>
      </div>

      {state === 'detecting' && (
        <p className="font-mono text-[11px] tracking-wider text-fg-muted mt-8">
          Detecting Telegram context...
        </p>
      )}

      {state === 'no-tg' && (
        <>
          <p className="text-fg-muted text-[14px] leading-relaxed mt-6 max-w-[300px]">
            SkinStep runs only inside the Telegram client. Open the app from{' '}
            <span className="text-fg">@skinstep_bot</span>.
          </p>
          <a
            href={BOT_LINK}
            className="mt-10 inline-flex items-center gap-2 border border-primary text-primary px-6 h-11 font-mono text-[12px] tracking-wider hover:bg-primary/10 transition-colors"
          >
            OPEN IN TELEGRAM ↗
          </a>
        </>
      )}

      {state === 'auth-failed' && (
        <>
          <p className="text-danger text-[14px] mt-6 max-w-[300px]">
            Could not authenticate this session.
          </p>
          {error && (
            <p className="font-mono text-[11px] text-fg-muted mt-2 break-words max-w-[320px]">
              {error}
            </p>
          )}
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="mt-8 border border-edge text-fg px-6 h-11 font-mono text-[12px] tracking-wider hover:border-primary/60 transition-colors"
            >
              RETRY
            </button>
          )}
        </>
      )}
    </div>
  );
}
